import { httpClient, mutationEndpoint } from '../system';

type PortfolioImageUploadArgs = {
  projectId: string;
  image: FormData;
  contactKey: string;
};

type PortfolioImageDeleteArgs = {
  projectId: string;
  imageId: string;
  contactKey: string;
};

const uploadPortfolioImage = mutationEndpoint({
  actionName: 'uploadPortfolioImage',
  mutationKey: ['upload-portfolio-image'],
  mutationFn: ({ projectId, image, contactKey }: PortfolioImageUploadArgs) => {
    const uploadPath = `/upload/${contactKey}/projects/${projectId}/portfolio-images`;

    return httpClient.auto({
      url: uploadPath,
      method: 'POST',
      data: image,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  onSuccess: (queryClient, _, { projectId }) => {
    queryClient.invalidateQueries({ queryKey: ['project', projectId] });
    queryClient.invalidateQueries({ queryKey: ['projects'] });
  },
});

const deletePortfolioImage = mutationEndpoint({
  actionName: 'deletePortfolioImage',
  mutationKey: ['delete-portfolio-image'],
  mutationFn: ({ projectId, imageId, contactKey }: PortfolioImageDeleteArgs) =>
    httpClient.auto({
      url: `/api/projects/portfolio/${projectId}/delete/${imageId}`,
      method: 'DELETE',
      headers: {
        'auth-key': contactKey,
      },
    }),
  onSuccess: (queryClient, _, { projectId }) => {
    queryClient.invalidateQueries({ queryKey: ['project', projectId] });
    queryClient.invalidateQueries({ queryKey: ['projects'] });
  },
});

export { deletePortfolioImage, uploadPortfolioImage };
